import Nav from '../../components/breadcrumb';
import PageHeader, { Title, ActionBar, ActionButton as Btn, ButtonToolbar } from './../../components/pageheader';
import { Form, Table, Card, Row, Col } from 'react-bootstrap';
import { SortButton } from './../../components/btns';
import { useState, useEffect, createElement, Fragment } from 'react';
import PagePagination, { usePagination } from './../../components/pagination';
import moment from 'moment';
import currency, { UGX } from './../../components/currency';
import { Link, useSearchParams } from 'react-router-dom';
import { UCWords, sortFunction } from './../../components/resources';
import { useScreenType } from './../../components/custom-hooks';
import { getExpenses } from '../../resources/api/expenses';
import { ErrorLoading, PageLoading } from '../../components/loading';
import { infoAlert } from '../../components/toastr';
import { createFile } from '../../components/exceller';

/**
 * View table items on screens larger than md
 * @param {{
 * srt: {currentField: string, currentOrder: string}
 * handleSort: (field: string) => void
 * items: import('../../resources/api/expenses').ExpenseObject[]
 * currentPage: number
 * noPageItems: number
 * }} param0 
 */
const ViewDesktop = ({ srt, handleSort, items, currentPage, noPageItems }) => {
    return (
        <Table responsive hover style={{ minWidth: '700px' }}>
            <colgroup>
                {/* <col span="1" style={{ width: "3%" }} />
                <col span="1" style={{ width: "17%" }} />
                <col span="1" style={{ width: "12%" }} />
                <col span="1" style={{ width: "15%" }} />
                <col span="1" style={{ width: "12%" }} />
                <col span="1" style={{ width: "12%" }} />
                <col span="1" style={{ width: "15%" }} />
                <col span="1" style={{ width: "18%" }} /> */}
            </colgroup>
            <thead>
                <tr>
                    <th>#</th>
                    <th>Ref <SortButton field="reference" {...srt} handleSort={handleSort} /></th>
                    <th>User Ref <SortButton field="user_reference" {...srt} handleSort={handleSort} /></th>
                    <th>Category <SortButton field="category" {...srt} handleSort={handleSort} /></th>
                    <th>Date <SortButton field="expense_date" {...srt} handleSort={handleSort} /></th>
                    <th style={{ textAlign: 'right' }}>Amount <SortButton field="amount" {...srt} handleSort={handleSort} /></th>
                    <th>Account <SortButton field="account" {...srt} handleSort={handleSort} /></th>
                    <th>Vendor <SortButton field="vendor" {...srt} handleSort={handleSort} /></th>
                    <th>Status <SortButton field="status" {...srt} handleSort={handleSort} /></th>
                </tr>

            </thead>
            <tbody>
                {items.map((e, i) => (
                    <tr key={i}>
                        <td>{(currentPage - 1) * noPageItems + i + 1}</td>
                        <td><Link to={`/app/expenses/${e.id}`}>{e.reference}</Link></td>
                        <td>{e.user_reference}</td>
                        <td>{UCWords(e.category.replace(/-/g, " "))}</td>
                        <td>{moment(e.expense_date).format("DD MMM YYYY")}</td>
                        <td style={{ textAlign: 'right' }}>{currency(e.amount).format()}</td>
                        <td>{<Link to={`/app/accounts/${e.account_id}`}>{e.account}</Link>}</td>
                        <td>{!!e.vendor ?
                            createElement(
                                !!e.vendor_id ? Link : Fragment,
                                !!e.vendor_id ? { to: `/app/vendors/${e.vendor_id}` } : "",
                                e.vendor
                            ) : 'n/a'}</td>
                        <td>{UCWords(e.status.replace(/-/g, " "))}</td>
                    </tr>
                ))}
            </tbody>
        </Table>
    )
}

/**
 * view items on screens smaller than md
 * @param {{
 * srt: {currentField: string, currentOrder: string}
 * handleSort: (field: string) => void
 * items: import('../../resources/api/expenses').ExpenseObject[]
 * }} param0 
 */
const ViewMobile = ({ srt, handleSort, items }) => {
    return (
        <div className="my-3">
            <div className="mb-3" style={{ whiteSpace: 'nowrap', overflowX: 'auto', maxWidth: '100%' }}>
                <span className="small text-nowrap m-1 py-1 px-2 bg-teal text-white rounded-pill">
                    Reference <SortButton field="reference" {...srt} handleSort={handleSort} />
                </span>
                <span className="small text-nowrap m-1 py-1 px-2 bg-teal text-white rounded-pill">
                    Date <SortButton field="expense_date" {...srt} handleSort={handleSort} />
                </span>
                <span className="small text-nowrap m-1 py-1 px-2 bg-teal text-white rounded-pill">
                    Category <SortButton field="category" {...srt} handleSort={handleSort} />
                </span>
                <span className="small text-nowrap m-1 py-1 px-2 bg-teal text-white rounded-pill">
                    Status <SortButton field="status" {...srt} handleSort={handleSort} />
                </span>
                <span className="small text-nowrap m-1 py-1 px-2 bg-teal text-white rounded-pill">
                    Date <SortButton field="expense_date" {...srt} handleSort={handleSort} />
                </span>
                <span className="small text-nowrap m-1 py-1 px-2 bg-teal text-white rounded-pill">
                    Amount <SortButton field="amount" {...srt} handleSort={handleSort} />
                </span>
                <span className="small text-nowrap m-1 py-1 px-2 bg-teal text-white rounded-pill">
                    Account <SortButton field="account" {...srt} handleSort={handleSort} />
                </span>
            </div>
            {items.map((e, i) => (
                <Card className="my-2 shadow-sm" key={i}>
                    <Card.Body className="px-3">
                        <div className="d-flex justify-content-between mb-3">
                            <Link to={`/app/expenses/${e.id}`} className="lead text-secondary font-weight-normal stretched-link">
                                {e.reference}
                            </Link>
                            <span className="text-muted">{moment(e.expense_date).format("DD MMM YYYY")}</span>
                        </div>

                        <div>
                            <span className="lead d-block">
                                {UCWords(e.category.replace(/-/g, " "))} {!!e.user_reference ? <>({UCWords(e.user_reference)})</> : ""}
                            </span>
                            <h4 className="h4">{UGX(e.total_amount).format()}</h4>
                            <span className="d-block">
                                {e.method} via <Link to={`/app/accounts/${e.account_id}`}>{e.account}</Link>
                            </span>
                        </div>

                        <div className="d-flex justify-content-between mt-3">
                            <span className="text-muted font-weight-normal">{e.vendor?.toLowerCase()}</span>
                            <span className="text-muted font-weight-normal">{e.status.replace(/-/g, " ").toLowerCase()}</span>
                        </div>
                    </Card.Body>
                </Card>
            ))}
        </div>
    )
}


const ViewExpenses = () => {

    const [navItems, setNavItems] = useState([{
        title: 'Expenses'
    }]);

    const [srt, setSrt] = useState({
        currentField: 'expense_date',
        currentOrder: 'desc'
    });

    const [noPageItems, setNoPageItems] = useState(10);
    const [displayItems, setDisplayItems] = useState([]);
    const [items, setItems] = useState([]);
    const [orginalItems, setOriginalItems] = useState([]);
    const [search, setSearch] = useState({ val: '', field: 'reference' });

    const [loaded, setLoaded] = useState(false);
    const [error, setError] = useState();

    const screenType = useScreenType();
    const [searchParams] = useSearchParams();
    const [PAGE, NOPAGES, setPage] = usePagination(items.length, noPageItems);


    /**
     * whenever the page changes, scroll back to the top of the list.
     */
    useEffect(() => {
        if (PAGE === 1) return;
        window.scrollTo({ top: 100, behavior: "smooth" });
    }, [PAGE])

    /**
     * whenever the value and field change ie. a search, 
     * filter the items and view on the page.
     */
    useEffect(() => {
        const v = search.val, f = search.field;
        if (v.length < 2 || f === "") return setItems(orginalItems);
        setItems([...orginalItems.filter(i => i[f].toLowerCase().indexOf(v.toLowerCase()) !== -1)]);
    }, [search.val, search.field, orginalItems]);


    /**
     * get the items
     */
    useEffect(() => {

        setLoaded(false);
        setError(null);

        let conditions = null,
            vendor_id = searchParams.get("vendor");

        if (vendor_id) conditions = { vendor_id };
        getExpenses(true, conditions)
            .then(({ expenses }) => {


                if (expenses.length > 0) {

                    if (vendor_id) {
                        let vendor = expenses[0].vendor;
                        setNavItems([{ title: "Expenses", href: `/app/expenses` }, { title: vendor }]);
                    }
                    else {
                        setNavItems([{ title: "Expenses" }]);
                    }

                    expenses.sort((a, b) => sortFunction(a, b, "expense_date", "desc"));
                    expenses = expenses.map(e => ({ ...e, vendor: (e.vendor || e.vendor_old) }));
                    setOriginalItems(expenses);
                    setItems(expenses);
                } else {
                    setNavItems([{ title: "Expenses" }]);
                    setOriginalItems([]);
                    setItems([]);
                }
            })
            .catch(e => setError(e))
            .finally(() => setLoaded(true))

    }, [searchParams])


    /**
     * Update display items whenever 
     * (1) => the page changes 
     * (2) => the number of items a page changes 
     * (3) => items change in any way
     */
    useEffect(() => {

        const ditems = [],
            start = (PAGE * noPageItems) - noPageItems,
            end = (PAGE * noPageItems) > items.length ? items.length : PAGE * noPageItems;

        for (let index = start; index < end; index++) {
            ditems.push(items[index]);
        }

        setDisplayItems(ditems);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [PAGE, noPageItems, JSON.stringify(items)])

    /**
     * Is triggered when 
     * (1) => user has changed the sort field
     * (2) => user has changed sort order
     * (3) => user has changed length of items (i.e., there are new items in the page)
     */
    useEffect(() => {

        const comp = (a, b) => {
            if (srt.currentOrder === 'asc') {
                return (a[srt.currentField] > b[srt.currentField]) ? 1 : ((a[srt.currentField] < b[srt.currentField]) ? -1 : 0);
            }
            return (a[srt.currentField] < b[srt.currentField]) ? 1 : ((a[srt.currentField] > b[srt.currentField]) ? -1 : 0);
        }

        setItems(items => [...items].sort(comp));

    }, [srt.currentField, srt.currentOrder, items.length])

    /**
     * handle when someone clicks the sort button
     * @param {string} field 
     */
    const handleSort = field => {
        if (field === srt.currentField) {
            setSrt(d => ({ ...d, currentOrder: d.currentOrder === 'asc' ? 'desc' : 'asc' }));
        } else {
            setSrt(d => ({ currentField: field, currentOrder: 'asc' }));
        }
    }


    const onDownloadClick = () => {


        infoAlert("Preparing download...");


        const headers = {
            "reference": "Reference",
            "category": "Expense Account",
            "expense_date": "Date",
            "account": "Bank Account",
            "method": "Payment Method",
            "status": "Status"
        };

        const keys = Object.keys(headers);


        let items = {
            expenses: []
        };

        items.expenses.push(keys.map(e => headers[e]));

        orginalItems.forEach(i => {
            items.expenses.push(keys.map(e => (e === "expense_date") ? moment(i[e]).format("DD MMM YYYY") : i[e]));
        })

        createFile(items, "Events UG Expenses.xlsx", "Company Expenses");

    }

    if (!loaded) return <PageLoading>Loading all expenses...</PageLoading>;

    if (error) return <ErrorLoading>{error}</ErrorLoading>;


    return (
        <>
            <Nav items={navItems} />

            <PageHeader maxWidth="1200">
                <Title>Expenses</Title>
                <ActionBar>
                    <ButtonToolbar>
                        <Btn onClick={onDownloadClick}>
                            <i className="fas fa-download me-1" />Download
                        </Btn>
                    </ButtonToolbar>
                    <ButtonToolbar>
                        <Btn href="/app/expenses/new">
                            <i className="fas fa-plus-circle me-1" />New Expense
                        </Btn>
                    </ButtonToolbar>
                </ActionBar>
            </PageHeader>

            <div className="max-1200">

                <Row xs={{ cols: "auto" }} className="align-items-center justify-content-md-end mb-3 flex-nowrap g-0">
                    <Col>

                        <Form.Control placeholder="Search For" size="sm"
                            value={search.val}
                            onChange={e => setSearch({ ...search, val: e.currentTarget.value })}
                        />
                    </Col>
                    <Col>
                        <span className="mx-1">in</span>
                    </Col>
                    <Col>
                        <Form.Select as="select" size="sm"
                            value={search.field}
                            onChange={e => setSearch({ ...search, field: e.currentTarget.value })}
                        >
                            <option value="vendor">Vendor</option>
                            <option value="category">Category</option>
                            <option value="reference">Reference</option>
                            <option value="user_reference">User Reference</option>
                            <option value="status">Status</option>
                        </Form.Select>
                    </Col>

                </Row>

                {screenType === 'desktop' ?
                    <ViewDesktop srt={srt} handleSort={handleSort} items={displayItems} noPageItems={noPageItems} currentPage={PAGE} /> :
                    <ViewMobile srt={srt} handleSort={handleSort} items={displayItems} />
                }

                <div className="d-flex flex-column flex-sm-row justify-content-between align-items-center">
                    <Row xs={{ cols: "auto" }} className="align-items-center g-0 flex-nowrap mb-2">

                        <Col className="me-2 text-nowrap">No Items:</Col>
                        <Col>
                            <Form.Select
                                value={noPageItems}
                                onChange={e => setNoPageItems(parseInt(e.currentTarget.value))}
                                size="sm"
                                style={{ maxWidth: '100px' }}
                            >
                                <option value={10}>10</option>
                                <option value={25}>25</option>
                                <option value={50}>50</option>
                                <option value={100}>100</option>
                            </Form.Select>
                        </Col>

                        <Col className="ms-2 text-nowrap">{items.length} of {orginalItems.length}</Col>
                    </Row>
                    <PagePagination
                        page={PAGE}
                        no_pages={NOPAGES}
                        setPage={setPage}
                    />
                </div>
            </div>

        </>
    )
}


export default ViewExpenses;